import type { StateStatus, StoreLogger } from "../types";

/**
 * Executes an async fetch operation with automatic status management.
 */
export async function withFetchStatus(
  setStatus: (status: StateStatus) => void,
  logger: StoreLogger,
  fn: () => Promise<void>,
): Promise<void> {
  try {
    setStatus("loading");
    await fn();
    setStatus("success");
  } catch (error) {
    logger.error(error);
    setStatus("error");
  }
}
